import { useAuth0 } from "@auth0/auth0-react";

export default function useMFAToken() {
  const { getAccessTokenSilently, getAccessTokenWithPopup } = useAuth0();

  const auth0URL = `https://${process.env.REACT_APP_AUTH0_ORIGINAL_DOMAIN}`;

  const getAccessToken = async (scope: string) => {
    const options = {
      audience: `${auth0URL}/mfa/`,
      scope,
    };

    try {
      return await getAccessTokenSilently(options);
    } catch (error) {
      try {
        return await getAccessTokenWithPopup(options);
      } catch (getAccessTokenWithPopupError) {
        throw getAccessTokenWithPopupError;
      }
    }
  };

  return {
    getAccessToken,
  };
}
